export default __webpack_public_path__ + "static/Theinhardt-Italic-subset-4063d1ef12f82a987a00e49ac39af6c8.woff";